exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.save{background-color:#00b0f0;box-shadow:inset 0 0 0 1px #3679e7}span.area-header{font-size:14px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/instrument_editor.css
// module id = 536
// module chunks = 0